import React from 'react'
import Layout from '../layouts'
import CommonHero from '../components/commonhero/commonhero.js'
import Form from '../components/form/form'

class ContactPage extends React.Component {
	render() {
		return (
			<Layout head={{ title: 'Armstrong Real Estate' }}>
				<CommonHero pageTitle="Contact Us" />
				<main className="bg-white contactforms rh_contact__form">
					<div className="contact-section py-5 leftconts">
						<div className="container">
							<div className="section-heading text-center" />
							<div className="section-content">
								<div className="row">
									<div className="col-md-6">
										<div>
											<Form
												form_name="contact"
												form_id="5da951c03f6fc55fb82ee8b7"
												className="topBefore"
												action="/thank-you"
												method="post"
											>
												<input
													type="hidden"
													name="subject"
													value="Contact Details"
												/>
												<p className="rh_contact__input rh_contact__input_text">
													<label for="name">Name</label>
													<input
														id="name"
														type="text"
														name="name"
														placeholder="Your Name"
														title="* Please provide your name"
														aria-required="true"
														className="required error"
													/>
												</p>
												<p className="rh_contact__input rh_contact__input_text">
													<label for="email">Email</label>
													<input
														id="email"
														type="text"
														name="email"
														placeholder="Your Email"
														title="* Please provide a valid email address"
														aria-required="true"
														required="required"
														className="email required error"
													/>
												</p>
												<p className="rh_contact__input rh_contact__input_text">
													<label for="number">Phone</label>
													<input
														id="number"
														type="text"
														name="number"
														placeholder="Your Phone"
													/>
												</p>
												<p className="rh_contact__input rh_contact__input_textarea">
													<label for="comment">Message</label>
													<textarea
														id="comment"
														cols="40"
														rows="6"
														name="message"
														placeholder="Your Message"
														title="* Please provide your message"
														aria-required="true"
														aria-invalid="true"
														className="required error"
													/>
												</p>
												<div className="mb-3">
													<div className="webriq-recaptcha" />
												</div>
												<p className="rh_contact__input rh_contact__submit">
													<input
														id="submit-button"
														type="submit"
														value="Send Message"
														name="submit"
														className="rh_btn rh_btn--primary"
													/>
												</p>
											</Form>
										</div>
									</div>
									<div className="col-md-6 leftconts">
										<div className="rh_contact__details">
											<div className="rh_contact__item">
												<p className="icon">
													<svg
														version="1.1"
														xmlns="http://www.w3.org/2000/svg"
														x="0px"
														y="0px"
														width="18px"
														height="18px"
														viewBox="0 0 459 459"
														style={{
															'enable-background': 'new 0 0 459 459',
														}}
													>
														<g>
															<g>
																<path d="M91.8,198.9c35.7,71.4,96.9,130.05,168.3,168.3L316.2,311.1c7.649-7.649,17.85-10.199,25.5-5.1                      c28.05,10.2,58.649,15.3,91.8,15.3c15.3,0,25.5,10.2,25.5,25.5v86.7c0,15.3-10.2,25.5-25.5,25.5C193.8,459,0,265.2,0,25.5                      C0,10.2,10.2,0,25.5,0h89.25c15.3,0,25.5,10.2,25.5,25.5c0,30.6,5.1,61.2,15.3,91.8c2.55,7.65,0,17.85-5.1,25.5L91.8,198.9z" />
															</g>
														</g>
													</svg>
												</p>
												<p className="content">
													<span className="label">Phone</span>
													<a href="tel:719-229-2755">719-229-2755</a>
												</p>
											</div>
											<div className="rh_contact__item">
												<p className="icon">
													<svg
														version="1.1"
														xmlns="http://www.w3.org/2000/svg"
														x="0px"
														y="0px"
														width="20px"
														height="20px"
														viewBox="0 0 510 510"
														style={{
															'enable-background': 'new 0 0 510 510',
														}}
													>
														<g>
															<g>
																<path d="M459,51H51C22.95,51,0,73.95,0,102v306c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V102                      C510,73.95,487.05,51,459,51z M459,153L255,280.5L51,153v-51l204,127.5L459,102V153z" />
															</g>
														</g>
													</svg>
												</p>
												<p className="content">
													<span className="label">Email</span>
													<a href="mailto:dan@armstrongrealestateco.com">
														dan@armstrongrealestateco.com
													</a>
												</p>
											</div>
											<div className="rh_contact__item">
												<p className="icon">
													<svg
														version="1.1"
														xmlns="http://www.w3.org/2000/svg"
														x="0px"
														y="0px"
														width="20px"
														height="30px"
														viewBox="0 0 425.963 425.963"
														style={{
															'enable-background': 'new 0 0 425.963 425.963',
														}}
													>
														<g>
															<path d="M213.285,0h-0.608C139.114,0,79.268,59.826,79.268,133.361c0,48.202,21.952,111.817,65.246,189.081                    c32.098,57.281,64.646,101.152,64.972,101.588c0.906,1.217,2.334,1.934,3.847,1.934c0.043,0,0.087,0,0.13-0.002                    c1.561-0.043,3.002-0.842,3.868-2.143c0.321-0.486,32.637-49.287,64.517-108.976c43.03-80.563,64.848-141.624,64.848-181.482                    C346.693,59.825,286.846,0,213.285,0z M274.865,136.62c0,34.124-27.761,61.884-61.885,61.884                    c-34.123,0-61.884-27.761-61.884-61.884s27.761-61.884,61.884-61.884C247.104,74.736,274.865,102.497,274.865,136.62z" />
														</g>
													</svg>
												</p>
												<p className="content">
													<span className="label">Address</span>1965 Dominion
													Way Suite 100 Colorado Springs, CO 80918
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-md-12 mapcont my-5">
										<iframe
											src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3104.0570710341744!2d-104.79286388826318!3d38.92267302880662!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87134ef0928f35c1%3A0xe7a8892700f43d5f!2s1965+Dominion+Way+%23100%2C+Colorado+Springs%2C+CO+80918%2C+USA!5e0!3m2!1sen!2sph!4v1512706391469"
											width="100%"
											height="450"
											frameborder="0"
											title="Google Map"
											style={{ border: 0 }}
											allowfullscreen=""
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
			</Layout>
		)
	}
}

export default ContactPage
